import { BlockWrapper } from "../Preview";
import React from "react";
import { generateCss } from "../../functions/sortableFunctions";

const TimerPopup = ({ block, ...props }: any) => {

	const [openDialog, setOpenDialog] = React.useState(false);

	React.useEffect(() => {

		let shouldAppear = true;

		if (block?.data?.persistIn === "localStorage") {
			const Key = block?.data?.persistKey;

			if (localStorage.getItem(Key) != undefined) {
				shouldAppear = localStorage.getItem(Key) === '0' ? true : false;
			}

		}
		else if (block?.data?.persistIn === "sessionStorage") {

			const Key = block?.data?.persistKey;

			if (sessionStorage.getItem(Key) != undefined) {
				shouldAppear = sessionStorage.getItem(Key) === '0' ? true : false;
			}
		}

		if (!shouldAppear) return;

		setTimeout(() => {
			setOpenDialog(true);
		}, block?.data?.openAfter)

	}, [])

	return (
		<React.Fragment>
			{
				openDialog &&
				React.createElement(
					block.data?.type ? block.data.type : 'div',
					{
						style: {
							fontFamily: block?.style?.fontFamily
						},
						className: generateCss({
							props: {
								...props,
								block: block
							},
						}),
						id: block.id,
						...block.data,
						onClick: () => {
							setOpenDialog(false);
						}
					},
					block.children.map((value: any, index: any) => {
						return <BlockWrapper
							{...props}
							key={index}
							block={value}
							openDialog={openDialog}
							setOpenDialog={setOpenDialog}
						/>
					})
				)
			}
		</React.Fragment>
	)
}

export default TimerPopup;